import React, { FC } from 'react'
import { useStoreon } from 'storeon/react'
import { useMediaQuery } from 'react-responsive'
import { State } from '@/interfaces'
import MenuSidebar from '../MenuSidebar'
import OpenOrCloseSidebar from '../OpenOrCloseSidebar'
import style from './styles/index.module.scss'
import PhoneSidebar from '../PhoneSidebar'
import UserAccount from '../UserAccount/UserAccount'
import { TYPE_USER } from '../../const'

interface ISidebar {
  logo?: string
  isOpenSidebar: boolean
  toggleOpenSidebar: () => void
}

const Sidebar: FC<ISidebar> = ({ isOpenSidebar, toggleOpenSidebar }) => {
  const { page, currentUser } = useStoreon<State>('page', 'currentUser')
  const { menus } = page?.data?.page?.global
  const isLaptop = useMediaQuery({
    query: '(min-width: 568px)'
  })
  return (
    <div className={style.sidebar}>
      <div className={style.sidebar__tab_group}>
        {!isLaptop && (
          <div className={style.wrapper}>
            <UserAccount />
          </div>
        )}
        <MenuSidebar isOpenSidebar={isOpenSidebar} {...menus} />
        {currentUser.user_status !== TYPE_USER.VIEWER && (
          <PhoneSidebar isOpenSidebar={isOpenSidebar} />
        )}
        <OpenOrCloseSidebar isOpenSidebar={isOpenSidebar} toggleOpenSidebar={toggleOpenSidebar} />
      </div>
    </div>
  )
}

export default Sidebar
